// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    imageContainer: {
      '& .chooseFileButton': {
        backgroundColor: theme.palette.primary.light,
      },
      '& .chooseFileButton:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  }),
);

export default useStyles;
